import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import moment from "moment";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import {
  formattedAmountWithoutAed,
  newFormattedAmount,
} from "../../../../utils/CommonFunction";
import styles from "./styles";
import { isEmpty } from "lodash";

const PaymentMilestoneList = ({ proposalDetails }) => {
  const [expandedGroups, setExpandedGroups] = useState([]);

  const toggleGroup = (groupId) => {
    setExpandedGroups((prevExpanded) =>
      prevExpanded.includes(groupId)
        ? prevExpanded.filter((id) => id !== groupId)
        : [...prevExpanded, groupId]
    );
  };

  return (
    <>
      {!isEmpty(proposalDetails?.payment_groups) && (
        <>
          <h3 style={styles.sub_heading}>Payment Groups</h3>
          <div style={styles.columnFlex}>
            {proposalDetails?.payment_groups?.map((group) => (
              <div key={group.group_id}>
                <div
                  style={{
                    ...styles.rowFlex,
                    justifyContent: "space-between",
                    borderRadius: "12px",
                    background: "#F7F7F7",
                    padding: "1vh 1vw",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      ...styles.rowFlex,
                      ...styles.small_sub_heading,
                      flex: 1,
                    }}
                  >
                    {group.group_name}
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Due Date</h3>
                    <div style={styles.small_sub_heading}>
                      {moment(group?.due_date).format("MMM DD, YYYY")}
                    </div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Status</h3>
                    <div style={styles.small_sub_heading}>{group.status}</div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Amount</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {group?.amount && renderCurrencyIcon('small')}
                      {formattedAmountWithoutAed(group?.amount)}
                    </div>
                  </div>
                  {group.milestones?.length > 0 ? (
                    <IconButton onClick={() => toggleGroup(group.group_id)}>
                      {expandedGroups.includes(group.group_id) ? (
                        <KeyboardArrowUp />
                      ) : (
                        <KeyboardArrowDown />
                      )}
                    </IconButton>
                  ) : (
                    <IconButton style={{ visibility: "hidden" }}>
                      {expandedGroups.includes(group.group_id) ? (
                        <KeyboardArrowUp />
                      ) : (
                        <KeyboardArrowDown />
                      )}
                    </IconButton>
                  )}
                </div>

                {expandedGroups.includes(group.group_id) && (
                  <div
                    style={{
                      ...styles.columnFlex,
                      ...styles.budgetContainer,
                      gap: "15px",
                      marginBottom: "1vh",
                    }}
                  >
                    {group.milestones.map((milestone) => (
                      <div
                        key={milestone.milestone_id}
                        style={{
                          ...styles.rowFlex,
                          gap: "0px",
                          alignItems: "flex-start",
                        }}
                      >
                        <ArrowIcon />
                        <div style={styles.budgetRow}>
                          <div style={{ ...styles.rowFlex, flex: 1 }}>
                            <Box display="flex" alignItems="center">
                              <Box
                                component="img"
                                src={
                                  milestone?.milestone_image
                                    ? milestone?.milestone_image?.path
                                    : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                                }
                                alt="Milestone Icon"
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: "8px",
                                  border: "2px solid white",
                                  boxShadow: "0px 4px 2.67px 0px #00000026",
                                  marginRight: 1,
                                }}
                              />
                              <span style={styles.small_sub_heading}>
                                {milestone.milestone_name}
                              </span>
                            </Box>
                          </div>
                          <div
                            style={{
                              ...styles.rowFlex,
                              ...styles.small_text,
                              flex: 1,
                            }}
                          >
                            {milestone?.tags === "Design" ? (
                              <NewDesignIcon />
                            ) : (
                              <NewRenovationIcon />
                            )}
                            {milestone?.tags}
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Start Date</h3>
                            <div style={styles.small_sub_heading}>
                              {milestone?.start_date
                                ? moment(milestone?.start_date).format(
                                    "MMM DD, YYYY"
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>End Date</h3>
                            <div style={styles.small_sub_heading}>
                              {milestone?.end_date
                                ? moment(milestone?.end_date).format(
                                    "MMM DD, YYYY"
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Amount</h3>
                            <div style={styles.small_sub_heading}>
                              {newFormattedAmount(milestone?.amount)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default PaymentMilestoneList;
